import * as React from 'react';
const SvgStop = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 17 12" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M.003 6a1 1 0 001 1h6.79c.472 0 .945-.034 1.413-.1l.96-.138.045.047-.742.464a10 10 0 00-1.764 1.405l-.413.412a1 1 0 001.414 1.413l3.8-3.8a1 1 0 00-.001-1.414l-3.8-3.793A1 1 0 007.293 2.91l.407.407A9.999 9.999 0 009.459 4.72l.753.472-.047.046-.959-.136a9.972 9.972 0 00-1.414-.101h-6.79a1 1 0 00-1 1L.003 6zm15 6a1 1 0 01-1-1V1a1 1 0 112 0v10a1 1 0 01-1 1z"
            fill="currentColor"
        />
    </svg>
);
export default SvgStop;
